<template>
    <div class="login" :class="{'cn':version == 1,'plant':domainName == 'plant'}">
        <div class="login_right" :class="{'elinker':domainName == 'elinker','room':domainName == 'room'||domainName == 'uvlight'}" v-if="domainName != 'plant'">
            <div class="imgLogo_box">
              <img src="../img/login_webLogo.png" v-if="domainName == 'iotena'">
              <img src="../img/logo_yl.png" v-if="domainName == 'elinker'">
              <img src="../img/login_webLogo2_.png" v-if="domainName == 'room'||domainName == 'uvlight'">
            </div>
            <p class="p2">{{$t('App.login.text1')}}</p>
            <p class="p3" v-if="version == 1">{{$t('App.login.text2')}}</p>
            <el-input
              class="input1"
              :placeholder="$t('App.login.text3')"
              v-model="username">
                <img slot="prefix" src="../img/svg/user_icon.svg" />
            </el-input>
            <el-input
              class="input2"
              show-password
              :placeholder="$t('App.login.text4')"
              v-model="password">
                <img slot="prefix" src="../img/svg/password_icon.svg" />
            </el-input>
            <div class="input3_box">
                <el-input
                  class="input3"
                  :placeholder="$t('App.login.text5')"
                  v-model="code">
                    <img slot="prefix" src="../img/svg/code_icon.svg" />
                </el-input>
                <div class="img_box" @click="getCodeImage">
                    <img :src="codeImage" />
                </div>
             </div>
            <div class="btn_box" @click="login">
                <span>{{$t('App.login.text6')}}</span>
            </div>
            <div class="flex_box">
                <el-checkbox v-model="checkboxRememberPassword">{{$t('App.login.text8')}}</el-checkbox>
                <span class="btn_span" @click="openPage('retrievePassword')">{{$t('App.login.text7')}}</span>
            </div>
            <div class="login_box">
                <div class="box1" v-if="version == 0">
                    <img src="../img/logo_1.png">
                    <span><a href="http://beian.miit.gov.cn" target="view_window">粤ICP备20011150号-1</a></span>
                </div>
                <!-- <p class="p4">Powered by <span @click="openWeb('https://www.iotena.com')">IOTENA</span> | <a href="http://www.beian.miit.gov.cn" target="view_window">粤ICP备20011150号-1</a></p> -->
                <p class="p4" v-if="version == 0">An Intelligent Health Enhancement Eco-System</p>
                <p class="p4" v-if="version == 0"> Powered by <span @click="openWeb('https://www.iotena.com')"><img src="../img/logo_iotena.png"></span></p>
                <p class="p4" v-if="version == 1&&domainName != 'lighting'">An Intelligent Health Enhancement Eco-System Powered by <span @click="openWeb('http://www.weclouds.xyz')" style="top: 0;left: 0.5rem;color: #3e328b;">WECLOUDS</span></p>
            </div>
            <!-- <p class="p4">粤ICP备20011150号-1 / Powered by © 2008-2019 IDSS.CN</p> -->
        </div>
        
			<div class="login_box" v-if="domainName == 'plant'">
				<img class="title" src="../img/login/login_logo.png"/>
				
				<el-input class="input" v-model="username" :placeholder="$t('App.login.text3')">
					<span slot="prefix" class="input_icon_5">
						<img class="input_icon" src="../img/login/login_accountName.png">
					</span>

				</el-input>
				<el-input class="input" show-password :placeholder="$t('App.login.text4')" v-model="password">
					<span slot="prefix" class="input_icon_5" >
						<img class="input_icon" src="../img/login/login_password.png">
					</span>
				</el-input>
				<div class="input_box">
					<el-input class="input" :placeholder="$t('App.login.text5')" v-model="code">
						<span slot="prefix" class="input_icon_5">
							<img class="input_icon" src="../img/login/login_VerificationCode.png">
						</span>
					</el-input>
					<div class="img_box" @click="getCodeImage">
						<img :src="codeImage" />
					</div>
				</div>
				<div class="forget_password_zny">
          <el-checkbox v-model="checkboxRememberPassword">{{$t('App.login.text8')}}</el-checkbox>
          <span class="btn_span" @click="openPage('retrievePassword')">{{$t('App.login.text7')}}</span>
				</div>
        
				<el-button class="btn" type="primary" @click="login()">{{ $t('App.login.text6') }}</el-button>
        
			</div>
      
			<p class="keepOnRecord" v-if="domainName == 'plant'">
				<a href="http://www.weclouds.xyz" target="view_window"><img class="record_img1"
						src="../img/login/iot_record1.png" /></a>
				<img class="record_img2" src="../img/login/iot_record2.png" >
				<a href="http://beian.miit.gov.cn" target="view_window"><img class="record_img3"
						src="../img/login/iot_record3.png"></a>
			</p>
    </div>
</template>

<script type="text/javascript">
    import allUrl from '../api/allUrl.js'
    import base from '../api/base.js'
    import jqueryK from '../api/jqueryK.js'
    import { mapGetters } from 'vuex'
    export default {
        name: 'login',
        data () {
            return {
                username:'',
                password:'',
                code:'',
                checkboxRememberPassword:false,
                codeImage:'',
            }
        },
        computed:{
            ...mapGetters({version:'version',routerStr:'routerStr',remRatio:'remRatio',domainName:'domainName'}),
        },
        mounted(){
            var storage = window.localStorage;
            storage.setItem('userData','');
            if(storage.getItem("rememberPassword")){
              this.checkboxRememberPassword = true;
              this.username = storage.getItem('udfn');
              this.password = storage.getItem('udfp');
              storage.getItem('udfp',jqueryK.base64Decode(this.password));
            }
            this.$store.commit('SIDEBARSHOW',{
                sideBarShow:false,
            })
            this.getCodeImage();
        },
        methods:{
            login(){
                var storage = window.localStorage;
                let client_key = jqueryK.md5(navigator.userAgent);
                base.ajax_post(
                    allUrl.login.login,
                    {
                        username:this.username,
                        password:this.password,
                        code:this.code,
                        client_key:client_key,
                        // version: this.version,
                    },
                    {},
                    data => {
                        this.$message({
                          showClose: true,
                          message: 'Login successfully',
                          type: 'success'
                        });
                        data.data.client_key = client_key;
                        data.data.version = this.version;
                        this.$store.commit('USERDATAFUN',{
                            username:data.data.username,
                            id:data.data.id,
                            role:data.data.role,
                            lastLoginTime:data.data.lastLoginTime,
                            client_key:data.data.client_key,
                            token:data.data.token,
                            number:data.data.number,
                            avatar:data.data.avatar,
                            version:data.data.version,
                        })
                        this.$router.push({path:'/dashboard'})
                        this.$store.commit('ROUTERSTRFUN',{
                          routerStr:'/dashboard',
                        })
                        storage.setItem('userData',JSON.stringify(data.data))
                        if(this.checkboxRememberPassword){
                          storage.setItem('rememberPassword','true');
                          storage.setItem('udfn',this.username);
                          storage.setItem('udfp',jqueryK.base64Encode(this.password));
                        }
                        
                        this.$store.commit('HEADERIDFUN',{
                            headerUpdate: this.headerUpdate+1,
                        })
                    },
                    this
                )
            },
            
            getCodeImage(){
              console.log(allUrl.login.get_code_image);
                base.ajax_post(
                    allUrl.login.get_code_image,
                    {
                        type:'0'
                    },
                    {},
                    data=>{
                        this.codeImage = data.data.path;
                    },
                    this
                )
            },
            openPage(val){
                window.open('#/'+val);
            },
            openWeb(val){
                window.open(val);
            },
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  .login{
    width: 100%;
    height: 100%;
    min-height: 54rem;
    // min-width: 120rem;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    display: flex;
    background-image: url('../img/login_bg.jpg');
    background-size: 100% 100%;
    background-position: center;
    &.cn{
      background-image: url('../img/login_bg_v1.png');
      .login_right{
        .p2{
          font-size: 3.5rem;
        }
        .p3{
          font-family:AlibabaPuHuiTiM;
          color:rgba(255,255,255,1);
        }
        .btn_box{
          background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
          border-color:rgba(0,0,0,0);
        }
        .flex_box{
          .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
            border-color: rgba(0,0,0,0);
            background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
          }
        }
      }
    }
    .login_right{
        position: absolute;
        right: 0;
        top:0;bottom: 0;
        padding-left: 3.75rem;
        width: 41.17rem;
        &.elinker{
            .imgLogo_box{
                margin-top: 5rem;
                height: 5.6rem;
                line-height:5.6rem;
            }
            .p2{
                margin-top: 2.9rem;
            }
        }
        &.room{
            .imgLogo_box{
                margin-top: 1rem;
                height: 14rem;
                line-height:5.6rem;
            }
            .p2{
                margin-top: -1rem;
            }
        }
      .imgLogo_box{
        height: 1.6rem;
        line-height: 1.6rem;
        margin-top: 7rem;
        img{
            height: 100%;
            // height: 100%;
        }
      }
      .p2{
        margin-top: 4.9rem;
        font-family: AlibabaPuHuiTiM;
        font-size: 5rem;
        color: #fff;
        letter-spacing: 0;
      }
      .p3{
        font-family: AlibabaPuHuiTiM;
        font-size: 1.83rem;
        color: #657085;
        letter-spacing: 0;

      }
      .el-input{
        width: 31.67rem;
        .el-input__inner{
          height: 3.33rem;line-height: 3.33rem;
          background: #F6F8FA;
          border-radius: 2px;
          border-radius: 2px;
        }
        img{
            margin: 1rem 0 0 0.3rem;
            height: 1rem;
        }
      }
      .input1{
        margin: 6rem 0 0 1rem;
      }
      .input2,{
        margin: 1.67rem 0 0 1rem;
        .el-input__icon{
            line-height: 3.33rem;
        }
      }
      .input3_box{
        margin: 1.67rem 0 0 1rem;
        display: flex;
        .input3{
          width: 20.5rem;
        }
        .img_box{
          background: #F2F2F2;
          // border: 1px solid #DDDDDD;
          border-radius: 2px;
          overflow: hidden;
          margin-left: 0.83rem;
          width: 10.33rem;
          cursor: pointer;
          img{
            width: 100%;height: 100%;
          }
        }
      }
      .btn_box{
        margin: 2.5rem 0 0.83rem 1rem;
        width: 31.67rem;
        height: 3.33rem;line-height: 3.33rem;
        text-align: center;
        background: #05CFAB;
        border: 1px solid #05CFAB;
        border-radius: 2px;
        cursor: pointer;
        span{
          font-family: PingFang-SC-Medium;
          font-size: 1.17rem;
          color: #FFFFFF;
          letter-spacing: 0;
          text-align: center;
        }
      }
      .flex_box{
        margin-left: 1rem;
        width: 31.67rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .el-checkbox{
            color: #fff;
        }
        .el-checkbox__input.is-checked+.el-checkbox__label{
            color: #fff;
        }
        .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
            background-color: #05CFAB;
            border-color: #05CFAB;
        }
        .btn_span{
          font-family: PingFang-SC-Medium;
          font-size: 1rem;
          color: #fff;
          letter-spacing: 0;
          text-align: right;
          line-height: 1.42rem;
          cursor: pointer;
        }
      }
      .login_box{
        position: absolute;
        left: 0;
        bottom: 1.08rem;
        width: 100%;
        // text-align: center;
        // img{
        //   width: 10rem;height: 2.42rem;
        // }
        .box1{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 0 4.75rem;
            padding-bottom: 0.2rem;
            border-bottom: 0.1rem solid #FFFFFF;
            img{
                width: 11rem;
            }
            a{
                font-family: AlibabaPuHuiTiR;
                font-size: 1rem;
                color: #FFFFFF;
                font-weight:500;
            }
        }
        .p4{
            font-family: AlibabaPuHuiTiR;
            font-size: 1rem;
            color: #FFFFFF;
            margin: 0 4.75rem;
            // letter-spacing: 0;
            span{
                display: inline-block;
                height: 2rem;
                position: relative;
                top: 0.8rem;
                left: -0.5rem;
                cursor: pointer;
                // color: #17598a;
                // font-size: 1.2rem;
                // font-weight:500;
                img{
                    height: 100%;
                }
            }
        }
      }
    }
    &.plant{
      background-image: url('../img/login/plant_login_bg.png');
      
      .login_box {
        position: absolute;
        top: 25%;
        // top: 23.75rem;
        right: 7.63rem;
        // width: 30rem;
        // height: 30rem;
        // background: #494c4f;
        display: flex;
        flex-flow: column;
        align-items: center;

        width: 31.58rem;
        height: 35.79rem;
        background: rgba(239, 242, 252, 0.8);
        border-radius: 0.26rem 0.26rem 0.26rem 0.26rem;
        border: 0.11rem solid rgba(255, 255, 255, 0.9);
        box-sizing: border-box;

        .forget_password_zny {
          width: 26rem;
          margin: 0 auto 2rem;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .el-checkbox__inner {
            background-color: rgba(5, 207, 171, 1);
            border-color: rgba(5, 207, 171, 1);
          }

          .el-checkbox__label,
          .btn_span {
            font-weight: 400;
            font-size: 0.92rem;
            color: #7B7A7A;
          }

          .btn_span {
            cursor: pointer;
          }
        }

        // justify-content: center;
        .title {
          width: calc(100% - 7.6rem);
          margin: 4rem auto 3rem;
        }

        .input_box {
          margin: 0 auto 1.25rem;
          width: 26rem;
          height: 3.33rem;
          display: flex;
          align-items: center;

          .input {
            width: 23.74rem;
            margin: 0 1rem 0 0;
          }

          .img_box {
            // width: 12rem;
            // height: 3.33rem;
            width: 5.3rem;
            height: 3.33rem;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }

        .input {
          margin: 0 auto 1.58rem;
          width: 26rem;
          height: 3.33rem;
          // border: 1px solid rgba(144, 155, 159, 0.1);

          ::-webkit-input-placeholder {
            /* WebKit browsers */
            font-family: PingFang-SC-Medium;
            color: #A5A7B1;
            font-weight: 500;
            font-size: 1rem;
          }

          ::-moz-placeholder {
            /* Mozilla Firefox 19+ */
            font-family: PingFang-SC-Medium;
            color: #A5A7B1;
            font-weight: 500;
            font-size: 1rem;
          }

          :-ms-input-placeholder {
            /* Internet Explorer 10+ */
            font-family: PingFang-SC-Medium;
            color: #A5A7B1;
            font-weight: 500;
            font-size: 1rem;
          }

          .input_icon_5 {
            font-family: PingFang-SC-Medium;
            font-size: 1rem;
            color: #ffffff;
            font-weight: 500;
            display: flex;
            align-items: center;
            height: 100%;

            .input_icon {
              margin: 0 0.8rem;
              width: 1.58rem;
            }
          }

          .el-input__inner {
            color: #1D223C;
            height: 3.33rem;
            line-height: 3.33rem;
            padding-left: 3.5rem;
            border: none;
            // background: rgba(6, 9, 17, 0.1);
            font-size: 1.05rem;
            background: rgba(255, 255, 255, 0.9);
          }

          .el-input__prefix {
            height: 3.33rem;
            line-height: 3.33rem;
            left: 0;
          }

          input:-webkit-autofill,
          input:-webkit-autofill:hover,
          input:-webkit-autofill:focus,
          input:-webkit-autofill:active {
            -webkit-transition-delay: 99999s;
            -webkit-transition: color 99999s ease-out,
              background-color 99999s ease-out;
          }
        }

        .btn {
          width: 26rem;
          height: 3.33rem;
          // background-image: linear-gradient(270deg, #852929 3%, #bb4545 99%);
          // width: 26.32rem;
          // height: 3.16rem;
          background: rgba(5, 207, 171, 1);
          border: none;
          border-radius: 0.26rem 0.26rem 0.26rem 0.26rem;
          // border-radius: 0.5rem;
          font-family: PingFangSC-Regular;
          font-size: 1.2rem;
          color: #ffffff;
        }
      }
      
      .keepOnRecord {
        position: absolute;
        bottom: 1.2rem;
        width: 100%;
        text-align: center;

        font-family: MicrosoftYaHei;
        font-size: 1rem;
        color: rgba(255, 255, 255, 0.6);

        .record_img1 {
          width: 18.09rem;
          height: 1.84rem;
        }

        .record_img2 {
          width: 0.33rem;
          height: 1.64rem;
        }

        .record_img3 {
          width: 12.11rem;
          height: 1.64rem;
        }

        &.keepOnRecord_73 {
          color: #74706d;

          a {
            color: #74706d;
          }
        }

        a {
          color: rgba(255, 255, 255, 0.6);
        }

        // font-weight: 400;
      }
    }
  }
</style>
